"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDeleteGraderPage = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const Util_1 = __importDefault(require("@common/Util"));
const AdminDeliverablesTab_1 = require("@frontend/views/AdminDeliverablesTab");
const UI_1 = require("../util/UI");
const AdminPage_1 = require("./AdminPage");
const AdminView_1 = require("./AdminView");
class AdminDeleteGraderPage extends AdminPage_1.AdminPage {
    constructor(remote) {
        super(remote);
        this.images = [];
    }
    getGraderImages(remote) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminDeleteGraderPage::getGraderImages(..) - start");
            const url = this.remote + "/portal/at/docker/images?filters=" + JSON.stringify({ reference: ["grader"] });
            const options = AdminView_1.AdminView.getOptions();
            const response = yield fetch(url, options);
            const body = yield response.json();
            Log_1.default.info("AdminDeleteGraderPage::init(..) - image list retrieved; # images: " + (body === null || body === void 0 ? void 0 : body.length));
            let images = [];
            for (const image of body) {
                const tag = image === null || image === void 0 ? void 0 : image.RepoTags[0];
                const id = image.Id;
                const created = new Date(image.Created * 1000);
                images.push({ sha: id, tag: tag, created: created });
            }
            images.sort(function (a, b) {
                return b.created.getTime() - a.created.getTime();
            });
            const deliverables = yield AdminDeliverablesTab_1.AdminDeliverablesTab.getDeliverables(remote);
            Log_1.default.info("AdminDeleteGraderPage::init(..) - # images before filtering: " + images.length);
            images = images.filter(function (image) {
                var _a, _b, _c;
                for (const deliv of deliverables) {
                    if (typeof ((_a = deliv === null || deliv === void 0 ? void 0 : deliv.autoTest) === null || _a === void 0 ? void 0 : _a.dockerImage) === "string" &&
                        typeof image.sha === "string" &&
                        image.sha.indexOf((_b = deliv === null || deliv === void 0 ? void 0 : deliv.autoTest) === null || _b === void 0 ? void 0 : _b.dockerImage) >= 0) {
                        Log_1.default.info("AdminDeleteGraderPage::init(..) - matched and removed for delivId: " +
                            deliv.id +
                            "; sha: " +
                            ((_c = deliv === null || deliv === void 0 ? void 0 : deliv.autoTest) === null || _c === void 0 ? void 0 : _c.dockerImage) +
                            "; and: " +
                            image.sha);
                        return false;
                    }
                }
                return true;
            });
            Log_1.default.info("AdminDeleteGraderPage::init(..) - # images after filtering: " + images.length);
            return images;
        });
    }
    init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const that = this;
            Log_1.default.info("AdminDeleteGraderPage::init(..) - start");
            UI_1.UI.showModal("Retrieving Grader Images.");
            this.images = yield this.getGraderImages(this.remote);
            const imgOptions = [];
            for (const deliv of this.images) {
                let sha = deliv.sha.substring(7);
                sha = sha.substring(0, 12);
                imgOptions.push("_" + sha + "_ (" + deliv.tag + ") " + deliv.created.toLocaleString());
            }
            UI_1.UI.setDropdownOptions("graderImagesSelect", imgOptions, null);
            document.querySelector("#adminRemoveGraderImagesButton").onclick = function (evt) {
                Log_1.default.info("AdminDeleteGraderPage::adminRemoveGraderImagesButton(..) - button pressed");
                evt.stopPropagation();
                that
                    .handleRemoveImagePressed()
                    .then(function () {
                    Log_1.default.info("AdminDeleteGraderPage::adminRemoveGraderImagesButton(..) - done");
                })
                    .catch(function (err) {
                    Log_1.default.info("AdminDeleteGraderPage::adminRemoveGraderImagesButton(..) - ERROR: " + err);
                });
            };
            document.querySelector("#graderImagesSelect").onclick = function (evt) {
                Log_1.default.info("AdminDeleteGraderPage::adminRemoveGraderImagesButton(..) - select changed");
                evt.stopPropagation();
            };
            UI_1.UI.hideModal();
        });
    }
    handleRemoveImagePressed() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminDeleteGraderPage::handleRemoveImagePressed(..) - start");
            try {
                UI_1.UI.showModal("Removing Grader Images.");
                const selector = document.querySelector("#graderImagesSelect");
                const selectedOptions = selector.selectedOptions;
                let removalCount = 0;
                for (const option of selectedOptions) {
                    const value = option.value;
                    Log_1.default.info("AdminDeleteGraderPage::handleRemoveImagePressed(..) - selected: " + value);
                    const sha = value.substring(1, value.indexOf("_ ("));
                    Log_1.default.info("AdminDeleteGraderPage::handleRemoveImagePressed(..) - removing image sha: " + sha);
                    const success = yield this.removeImage(sha);
                    Log_1.default.info("AdminDeleteGraderPage::handleRemoveImagePressed(..) - image sha removal success; sha: " + sha + "; success: " + success);
                    if (success) {
                        removalCount++;
                    }
                }
                Log_1.default.info("AdminDeleteGraderPage::handleRemoveImagePressed(..) - done; images removed.");
                UI_1.UI.showSuccessToast(removalCount + " grader images successfully removed.");
            }
            catch (err) {
                Log_1.default.error("AdminDeleteGraderPage::handleRemoveImagePressed(..) - ERROR: " + err);
                UI_1.UI.showErrorToast("Grader image removal error: " + err);
            }
            UI_1.UI.hideModal();
            this.clearLists();
            void this.init({});
        });
    }
    removeImage(sha) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminDeleteGraderPage::removeImage( " + sha + " ) - start");
            const url = this.remote + "/portal/at/docker/image/" + sha;
            const options = AdminView_1.AdminView.getOptions();
            options.method = "delete";
            Log_1.default.trace("AdminDeleteGraderPage::removeImage(..) - DELETE from: " + url);
            const start = Date.now();
            const response = yield fetch(url, options);
            const json = yield response.json();
            if (typeof json.success !== "undefined") {
                Log_1.default.info("AdminDeleteGraderPage::removeImage(..) - success; took: " + Util_1.default.took(start));
                return json.success;
            }
            else {
                Log_1.default.error("AdminDeleteGraderPage::removeImage(..) - ERROR: " + json.failure);
            }
        });
    }
    clearLists() {
        const toProvisionSelect = document.getElementById("graderImagesSelect");
        toProvisionSelect.disabled = false;
        toProvisionSelect.innerHTML = "";
    }
    renderPage(pageName, opts) {
        Log_1.default.info("AdminProvisionPage::renderPage( " + pageName + ", ... ) - start");
    }
}
exports.AdminDeleteGraderPage = AdminDeleteGraderPage;
